import { LocaleObject } from "yup";
import { __ } from "@wordpress/i18n";

export const validationsLocale: LocaleObject = {};
